import { Button, type ButtonProps } from "@mantine/core"

export function ButtonSurvey({
  children,
  onClick,
  hidden,
  ...props
}: {
  onClick?: () => void
  hidden?: boolean
} & ButtonProps) {
  if (hidden) return null

  return (
    <Button size="lg" fullWidth maw={300} onClick={onClick} {...props}>
      {children}
    </Button>
  )
}
